<template>
  <div id="app"><router-view /></div>
</template>

<script>

export default {
  name: 'App'
};
</script>
<style lang="less" scoped>
  #app{
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom:env(safe-area-inset-bottom);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue